var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'puzzle mt-4',
    {
      'print-answer': _vm.showAnswer,
      'print-question': _vm.showQuestion,
      'puzzle-border-radius': _vm.settings.puzzleTypeStyle === 'radius',
      'puzzle-font-times': _vm.settings.puzzleTypeStyle === 'times',
    },
  ],style:({
    'grid-template-rows': `repeat(${_vm.rows}, ${_vm.cellSize}px)`,
    'grid-template-columns': `repeat(${_vm.columns}, ${_vm.cellSize}px)`,
  })},_vm._l((_vm.table),function(cell,index){return _c('puzzle-cell',{key:`${cell.positiony}-${cell.positionx}`,ref:"puzzleCell",refInFor:true,class:{ 'is-thinking': _vm.isGenerating && _vm.isCurrentScan(cell) },attrs:{"cell":cell,"data-index":index,"template-mode":_vm.templateMode,"is-planning-mode":_vm.canEditQuestions}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }